import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import { useAdaStore } from '../stores/ada'
import { useConfigStore } from '../stores/config'
import { usePageStore } from '../stores/page'
import { useSourcepointStore } from '../stores/sourcepoint'

import type { PropType } from 'vue'

export interface ConsentConfig {
  [key: string]: any
}

export interface AdSizePrediction {
  [key: string]: any
}

export interface Config {
  [key: string]: any
}

export default defineComponent({
  name: 'UseDefaultAppInit',
  props: {
    brand: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    consentConfig: {
      type: Object as PropType<ConsentConfig>,
      default: () => ({})
    },
    adSizePrediction: {
      type: Object as PropType<AdSizePrediction>,
      default: () => ({})
    },
    config: {
      type: Object as PropType<Config>,
      default: () => ({})
    }
  },
  computed: {
    ...mapState(useConfigStore, ['rsConfig'])
  },
  methods: {
    ...mapActions(useConfigStore, ['setRsConfig']),
    ...mapActions(usePageStore, ['fetchPage', 'appMounted']),
    ...mapActions(useSourcepointStore, ['setConsentConfig']),
    ...mapActions(useAdaStore, ['setAdSizePrediction'])
  },
  async mounted () {
    await this.appMounted()
  },
  async serverPrefetch () {
    const { url, brand, consentConfig, adSizePrediction, config } = this

    this.setConsentConfig(consentConfig)
    this.setRsConfig(config)
    this.setAdSizePrediction(adSizePrediction)

    return this.fetchPage({ url, brand, rsConfig: this.rsConfig })
  }
})
